module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av267-b54208829bf02547ac79cd9032e17fa8.jpg";